import { useMemo } from 'react';
import { useAsync } from '@/hooks/useAsync';

export const useBaseService = <TData, TArgs extends unknown[]>(
  serviceFn: (...args: TArgs) => Promise<TData>,
) => {
  const { data, error, loading, execute, reset } = useAsync(serviceFn);

  return useMemo(
    () => ({
      data,
      error,
      loading,
      execute,
      reset,
    }),
    [data, error, loading, execute, reset],
  );
};
